// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { UserService } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Service/User';
import { ERR_TER_USER_SVC, SUC_TER_USER_SVC } from '../../../../utils/strings';

export const useTerminateUserService = () => {
  const { submit } = useExerciseSubmission(
    UserService.UserService_Terminate,
    SUC_TER_USER_SVC,
    ERR_TER_USER_SVC,
  );
  return submit;
};
